import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState } from 'react';
import Content from './components/Content';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { HelpItem } from './model/HelpItem';
import { useStyles } from './styles';
import { darkTheme, lightTheme } from './themes/theme';

interface ApiDocsProps {
    apiVersion: string;
    handleVersionChange: (version: string) => void;
    darkMode: boolean;
    handleDarkModeChange: () => void;
    versions: string[];
    helpItems: HelpItem[];
}

function getDefaultLanguage() {
    const lang = localStorage.getItem('language');
    if (lang) {
        return JSON.parse(lang);
    }
    return 'C#';
}

function getDefaultTranslation() {
    const translated = localStorage.getItem('translated');
    if (translated) {
        return JSON.parse(translated);
    }
    return true;
}
const ApiDocs: React.FC<ApiDocsProps> = ({apiVersion, handleVersionChange, versions, helpItems, darkMode, handleDarkModeChange}) => {
    const classes = useStyles();
    const isLargeScreen = useMediaQuery('(min-width:1200px)');
    const [open, setOpen] = useState(isLargeScreen);

    const [language, setLanguage] = useState(getDefaultLanguage());
    const [translated, setTranslated] = useState(getDefaultTranslation());
    
    useEffect(() => {
        setOpen(isLargeScreen);
    }, [isLargeScreen]);

    const handleDrawerToggle = () => setOpen(!open);

    const handleLanguageChange = (language: string) => {
        setLanguage(language);
        localStorage.setItem('language', JSON.stringify(language));
    }

    const handleTranslationChange = () => {
        setTranslated(!translated);
        localStorage.setItem('translated', JSON.stringify(!translated));
    }

    const theme = darkMode ? darkTheme : lightTheme;
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={classes.root}>
                <Header
                    handleDrawerToggle={handleDrawerToggle}
                    handleDarkModeChange={handleDarkModeChange}
                    handleLanguageChange={handleLanguageChange}
                    handleVersionChange={handleVersionChange}
                    handleTranslationChange={handleTranslationChange}
                    language={language}
                    versions={versions}
                    apiVersion={apiVersion}
                    darkMode={darkMode}
                    isLargeScreen={isLargeScreen}
                    translated={translated}
                />
                <Box sx={{ display: 'flex', flexGrow: 1 }}>
                    {helpItems.length > 0 && (
                        <Sidebar helpItems={helpItems} open={open} isLargeScreen={isLargeScreen} apiVersion={apiVersion} translated={translated}/>
                    )}
                    <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                        {helpItems.length > 0 && (
                            <Content language={language} versions={versions} defaultItem={helpItems[0].url} translated={translated} />
                        )}
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default ApiDocs;